import { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement>;

export const LogoSmallSvg = ({ color = 'currentColor', ...props }: Props) => (
  <svg
    width="22"
    height="24"
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_logo_small)">
      <path
        d="M21.892 15.4723C21.7549 15.0066 21.4687 14.575 21.0652 14.2254L19.8954 13.212L17.9961 14.8578L19.3996 16.0755C19.4443 16.1139 19.4699 16.1702 19.4699 16.2293C19.4699 16.2884 19.4443 16.3447 19.3996 16.3831L15.0661 20.1382C12.9395 21.9811 9.73176 21.9804 7.60514 20.1382L3.39308 16.4885C2.81064 15.9843 2.4768 15.2523 2.4768 14.481V9.51896C2.4768 8.74773 2.81064 8.01567 3.39308 7.51148L7.60585 3.86185C8.63435 2.97027 9.95906 2.47962 11.3363 2.47962C12.7136 2.47962 14.0383 2.97027 15.0668 3.86185L19.4067 7.62186C19.4514 7.66032 19.477 7.71658 19.477 7.77568C19.477 7.83479 19.4514 7.89105 19.4067 7.9295L11.3363 14.9218L7.96455 12.0007L11.3363 9.07887L13.3074 10.7894L15.2032 9.14652L12.7903 7.05572C11.9614 6.3379 10.7113 6.3379 9.88234 7.05572L6.04249 10.3828C5.57369 10.7894 5.30449 11.3783 5.30449 12C5.30449 12.6217 5.57369 13.2113 6.04249 13.6172L9.88234 16.9443C10.7113 17.6628 11.9614 17.6628 12.7903 16.9443L21.0659 9.7739C21.4694 9.42425 21.7549 8.99341 21.8927 8.52697C22.1825 7.5421 21.8736 6.47606 21.1057 5.81022L16.6877 1.98184C15.1613 0.660851 13.2484 0 11.3363 0C9.4242 0 7.51138 0.660851 5.98566 1.98184L1.77361 5.63148C0.646369 6.60851 0 8.02492 0 9.51896V14.481C0 15.9744 0.646369 17.3915 1.77361 18.3685L5.98566 22.0182C7.46095 23.2964 9.36099 24 11.3356 24C13.3102 24 15.211 23.2964 16.6863 22.0182L21.1043 18.1898C21.8728 17.5239 22.1818 16.4572 21.8913 15.473L21.892 15.4723Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_logo_small">
        <rect width="22" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
